// js/data/LunettesIcons.js

const lunettesIcons = [
  { name: "triangle", file: "./assets/svg/lunettes/triangle.svg" },
  { name: "moon",     file: "./assets/svg/lunettes/moon.svg" },
  { name: "hexa",     file: "./assets/svg/lunettes/hexa.svg" },
  { name: "circle",   file: "./assets/svg/lunettes/circle.svg" },
  { name: "drop",     file: "./assets/svg/lunettes/drop.svg" },
  { name: "square",   file: "./assets/svg/lunettes/square.svg" },
  { name: "classic",  file: "./assets/svg/lunettes/classic.svg" },
  { name: "special",  file: "./assets/svg/lunettes/special.svg" },
  { name: "heart",    file: "./assets/svg/lunettes/heart.svg" },
  { name: "sparkle",  file: "./assets/svg/lunettes/sparkle.svg" },
  { name: "aviator",  file: "./assets/svg/lunettes/aviator.svg" },
  { name: "starlet",  file: "./assets/svg/lunettes/starlet.svg" },
];

// console.log("✅ LunettesIcons chargé, premier élément :", lunettesIcons[0]);

export default lunettesIcons;